import styled from 'styled-components';

export const CalendarSwitchWrapper = styled.div`
  width: 6rem;
`;
